import { render, staticRenderFns } from "./CollectionAgingView.vue?vue&type=template&id=d91005ec&scoped=true&"
import script from "./CollectionAgingView.vue?vue&type=script&lang=ts&"
export * from "./CollectionAgingView.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionAgingView.vue?vue&type=style&index=0&id=d91005ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91005ec",
  null
  
)

export default component.exports